import { FDealType } from '../../../packages/JsonQuery';
import { EPageType, TPageType } from 'shared/types/page';

export const isRentDailyOnMain = (dealType: FDealType, pageType: TPageType | undefined): boolean => {
  return dealType === FDealType.RentDaily && pageType === EPageType.MAIN;
};
